import type { IRecordTypeDefinition, ITreeNode } from '@platform/core/types';
import { treeDefault } from '../../fields/options/treeDefault';

/**
 * Типові значення нового запису (прототип v4, createRecord; UIUX field-types/area-path, iteration-path): виконавець — поточний
 * користувач, напрям — корінь дерева напрямів робочого простору, ітерація — поточний спринт (найглибший вузол, що містить сьогодні;
 * обидва — treeDefault контролів полів). Лише для полів, які тип має. Чиста функція.
 */
export function newRecordDefaults(rt: Pick<IRecordTypeDefinition, 'fields'>, meId: string | undefined, areas: readonly ITreeNode[], iterations: readonly ITreeNode[], today: string): Record<string, unknown> {
  const has = (key: string, type: string) => rt.fields.some((f) => f.key === key && f.type === type);
  const out: Record<string, unknown> = {};
  if (meId && has('assignee', 'user')) out['assignee'] = meId;
  const area = has('area', 'area') ? treeDefault([...areas], 'area', today) : null;
  if (area) out['area'] = area;
  const iteration = has('iteration', 'iteration') ? treeDefault([...iterations], 'iteration', today) : null;
  if (iteration) out['iteration'] = iteration;
  return out;
}
